<template>
  <aside class="guard-call-panel-skeleton">
    <div class="guard-call-panel-skeleton__partner-row">
      <span class="guard-call-panel-skeleton__badge"></span>
      <div class="guard-call-panel-skeleton__chip"></div>
    </div>
    <div class="guard-call-panel-skeleton__feed-card">
      <div class="guard-call-panel-skeleton__feed"></div>
      <div class="guard-call-panel-skeleton__feed-footer">
        <div class="guard-call-panel-skeleton__pill"></div>
      </div>
    </div>
    <div class="guard-call-panel-skeleton__call-section">
      <div class="guard-call-panel-skeleton__call-btn"></div>
      <div class="guard-call-panel-skeleton__call-avail"></div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "CallPanelSkeleton",
};
</script>

<style scoped lang="scss">
@import '../styles';

.guard-call-panel-skeleton {
  @include guard-panel-guard;

  &__partner-row {
    @include guard-flex-center-between;
    flex-shrink: 0;
  }
  &__badge { @include guard-skeleton($dark: true, $radius: $guard-radius-sm); width: 90px; height: 14px; }
  &__chip { @include guard-skeleton($dark: true, $radius: $guard-radius-sm); width: 120px; height: 24px; }

  &__feed-card { @include guard-card-dark; }
  &__feed {
    @include guard-skeleton($dark: true, $radius: $guard-radius-lg $guard-radius-lg 0 0);
    flex: 1;
    width: 100%;
  }
  &__feed-footer {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0.6rem 0.9rem;
    background: $guard-navy-900;
  }
  &__pill { @include guard-skeleton($dark: true, $radius: $guard-radius-pill); width: 110px; height: 14px; }

  &__call-section {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &__call-btn { @include guard-skeleton($dark: true, $radius: $guard-radius-md); width: 100%; height: 64px; }
  &__call-avail { @include guard-skeleton($dark: true, $radius: $guard-radius-sm); width: 80px; height: 10px; margin: 0 auto; }
}
</style>